import React from 'react';

import { isB2C } from '@/core/settings/utils';
import { Clock } from '@/core/tamagoshi/icons/Clock';
import { ManomanoNutLogo } from '@/core/tamagoshi/Logos/ManomanoNutLogo/ManomanoNutLogo';
import { ManomanoNutLogoB2B } from '@/core/tamagoshi/Logos/ManomanoNutLogoB2B/ManomanoNutLogoB2B';
import { freeDeliveryByMM } from '@/productDiscovery/ProductCard/translations';
import { useDeliveryMeta } from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';
import { Bullet } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/Bullet';
import { manoFulfillmentLabelFree } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/components/ManoFulfillment/translations';
import { FulfillmentContent } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/GoodToKnowUtils';
import { claimExpress } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/translations';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

export const DeliveryBullets = () => {
  const { delivery } = useDetail();
  const { hasExpressDelivery } = useDeliveryMeta();
  if (!hasExpressDelivery && !delivery?.fulfillment) {
    return null;
  }

  if (delivery?.fulfillment) {
    return (
      <Bullet
        icon={isB2C() ? <ManomanoNutLogo /> : <ManomanoNutLogoB2B />}
        modalContent={<FulfillmentContent />}
        modalHeader={manoFulfillmentLabelFree}
      >
        {freeDeliveryByMM}
      </Bullet>
    );
  }

  return <Bullet icon={<Clock />}>{claimExpress}</Bullet>;
};
